import React from 'react';
import Select from 'react-select';

const MultiSelect = ({ label, options, value, onChange, placeholder }) => {
  const handleSelectionChange = (selectedOptions) => {
    // Map selected options to extract only the `value`
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    onChange(selectedValues); // Pass only the `value` array to the parent
  };

  return (
    <div>
      <label>{label}</label>
      <Select
        isMulti
        options={options}
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => e.value} // Ensure this matches the `value` key in the options
        value={options.filter(option => value.includes(option.value))} // Match based on the `value`
        onChange={handleSelectionChange}
        placeholder={placeholder}
        isSearchable
      />
    </div>
  );
};

export default MultiSelect;
